<div (click)="getFeeddetail()">
    <div *ngIf="callingfrom!='journaldetail'">
    <div class="p-2 bg-white rounded-top">
        <div class="elips-content">
        <p class="fnt-weight500">{{sugglistObj?.heading}}</p>
        </div>
    </div>
    <div class="position-relative detail-suggestion-card-img">
    <!-- <img class="w-100" src={{sugglistObj?.media?.media_url}} onerror="this.src='assets/images/grandround/image_placeholder.svg'" /> -->

    <img class="w-100" *ngIf="sugglistObj?.media?.media_type=='video'  ||  sugglistObj?.media?.media_type=='document'  "    src={{sugglistObj?.media?.media_thumbnail}}  onerror="this.src='assets/images/grandround/image_placeholder.svg'" >
    <img class="w-100" *ngIf="sugglistObj?.media?.media_type=='image'" src={{sugglistObj?.media?.media_url}} onerror="this.src='assets/images/grandround/image_placeholder.svg'" >
    <!-- timer and reward -->
    <div class="position-absolute text-white fnt-size12px pl-1 pr-1 timer-doctalk rounded"><p>{{sugglistObj?.tag1}}</p></div>
    <div  class="position-absolute text-white fnt-size12px pl-1 pr-1 timer-doctalk rounded" style="left: auto !important; right: 8px !important;"><p>{{sugglistObj?.tag2}}</p></div>
    </div>
    <div class="p-2 bg-white rounded-bottom fnt-size14px">
        <div class="elips-content">
        <p>{{sugglistObj?.description }}</p>
        </div>
    </div>
</div>


<!-- journal -->
<div class="clearfix" *ngIf="callingfrom=='journaldetail'">
        <div class="float-left mr-2 w-100" style="max-width: calc(100% - 128px);">
        <div class="pl-2 pt-2 pb-2 fnt-size14px">
            <div class="elips-content">
            <p class="fnt-size14px fnt-weight500 text-very-dark-grey">{{sugglistObj?.description }}</p>
            <p class="fnt-size12px text-medium-grey text-truncate">{{sugglistObj?.heading}}</p>
            </div>
        </div>
        </div>
        <div class="float-left user-150">
        <div class="position-relative">
                <!-- <img class="w-100" src={{sugglistObj?.media?.media_url}} onerror="this.src='assets/images/grandround/image_placeholder.svg'" /> -->
            
                <img class="user-150 post-pic" *ngIf="sugglistObj?.media?.media_type=='video'  ||  sugglistObj?.media?.media_type=='document'  "    src={{sugglistObj?.media?.media_thumbnail}}  onerror="this.src='assets/images/grandround/image_placeholder.svg'" >
                <img class="user-150 post-pic" *ngIf="sugglistObj?.media?.media_type=='image'" src={{sugglistObj?.media?.media_url}} onerror="this.src='assets/images/grandround/image_placeholder.svg'" >
                <!-- timer and reward -->
                <div class="position-absolute text-white fnt-size12px pl-1 pr-1 timer-doctalk rounded"><p>{{sugglistObj?.tag1}}</p></div>
                <div  class="position-absolute text-white fnt-size12px pl-1 pr-1 timer-doctalk rounded" style="left: auto !important; right: 8px !important;"><p>{{sugglistObj?.tag2}}</p></div>
        </div>
        </div>
    </div>
</div>
